export default __webpack_public_path__ + "static/poster-2-79fb8ca28e2c50a53cd8bce7ae978431.webm";